<template>
	<div class="page">
		<Tip :tip="tip" />
		<div class="from_div">
			<el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="100px">
				<!-- <el-form-item v-if="from != 0" label="商业创建人：" style="margin-bottom: 5px;">
					<span>财务经理 胡凯 13345677876</span>
				</el-form-item> -->
				<el-form-item label="单据类型：" style="margin-bottom: 5px;">
					<span>{{checkList[from]}}</span>
				</el-form-item>
				<el-form-item label="简要名称：" prop="procurement_name">
					<el-input class="input" v-model="form.procurement_name" placeholder="如：建行中秋员工节礼" />
				</el-form-item>
				<el-form-item label="客户单位：" prop="consumer_id">
					<el-select class="select" v-model="form.consumer_id" filterable clearable placeholder="客户列表">
						<el-option v-for="item in consumerList" :key="item.consumer_id" :label="item.consumer_name"
							:value="item.consumer_id" />
					</el-select>
					<span v-if="form.consumer_id != ''" class="check_span" @click="consumerClick(form.consumer_id)">查看该客户档案</span>
					<span class="add_span" @click="consumerClick(-1)">+ 新增客户档案</span>
				</el-form-item>
				<div class="row">
					<el-form-item label="关联商机：" prop="opportunity_id">
						<el-select :disabled="opportunityList.length == 0" class="select" v-model="form.opportunity_id"
							filterable clearable placeholder="商机列表" @change="opportunityChange">
							<el-option v-for="item in opportunityList" :key="item.procurement_id"
								:label="item.procurement_name" :value="item.procurement_id" />
						</el-select>
					</el-form-item>
					<el-form-item label-width="0" prop="quotation_id">
						<el-select :disabled="quotationList.length == 0" class="select" style="margin: 0 30px;"
							v-model="form.quotation_id" filterable clearable placeholder="报价单列表">
							<el-option v-for="item in quotationList" :key="item.procurement_id"
								:label="item.procurement_name" :value="item.procurement_id" />
						</el-select>
					</el-form-item>
					<el-form-item label-width="0" prop="contract_id">
						<el-select :disabled="contractList.length == 0" class="select" v-model="form.contract_id"
							filterable clearable placeholder="合同列表">
							<el-option v-for="item in contractList" :key="item.procurement_id"
								:label="item.procurement_name" :value="item.procurement_id" />
						</el-select>
					</el-form-item>
				</div>
				<el-form-item label="项目概述：" prop="procurement_info">
					<el-input type="textarea" class="textarea" :placeholder="textarea"
						v-model="form.procurement_info" />
				</el-form-item>
				<div class="row">
					<el-form-item label="时间要求：" prop="procurement_start">
						<el-date-picker class="picker" :clearable='false' align="center"
							value-format="yyyy-MM-dd HH:mm:ss" v-model="form.procurement_start" type="datetime"
							placeholder="开始时间" />
					</el-form-item>
					<el-form-item label-width="20px" prop="procurement_end">
						<el-date-picker class="picker" :clearable='false' align="center"
							value-format="yyyy-MM-dd HH:mm:ss" v-model="form.procurement_end" type="datetime"
							placeholder="结束时间" />
					</el-form-item>
				</div>
				<el-form-item label="货物明细：">
					<el-table class="table_div" :data="form.procurement_goods" :header-cell-style="tabStyle">
						<el-table-column label="排序" width="100" align="center">
							<template slot-scope="scope">
								<el-input style="width: 80px" v-model="scope.row.sort" placeholder="0" />
							</template>
						</el-table-column>
						<el-table-column label="商品名称" width="250" prop="good_name">
							<template slot-scope="scope">
								<el-input style="width: 190px;" v-model="scope.row.good_name" placeholder="商品名称" />
							</template>
						</el-table-column>
						<el-table-column label="规格" prop="sku_name">
							<template slot-scope="scope">
								<el-input style="width: 100px;" v-model="scope.row.sku_name" placeholder="商品规格" />
							</template>
						</el-table-column>
						<el-table-column label="数量" prop="quatity">
							<template slot-scope="scope">
								<el-input style="width: 100px" v-model="scope.row.quatity" placeholder="0"
									@input="quatityInput(scope.$index)" />
							</template>
						</el-table-column>
						<el-table-column label="单价" prop="sale_price">
							<template slot-scope="scope">
								<el-input style="width: 100px;" v-model="scope.row.sale_price" placeholder="0.00"
									@input="priceInput(scope.$index)" />
							</template>
						</el-table-column>
						<el-table-column label="金额" prop="amount">
							<template slot-scope="scope">
								<el-input disabled style="width: 100px;" v-model="scope.row.amount"
									placeholder="0.00" />
							</template>
						</el-table-column>
						<el-table-column label="备注说明" prop="remark">
							<template slot-scope="scope">
								<el-input style="width: 100px;" v-model="scope.row.remark" placeholder="备注说明" />
							</template>
						</el-table-column>
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<el-button class="item_btn" size="mini" type="danger"
									@click="deleteItem(scope.$index,0)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="row">
						<el-button class="screen_btn" type="primary"
							@click="addItem(form.procurement_goods.length+1,0)">+表格加品</el-button>
						<el-button class="screen_btn" type="success" @click="open()">+关联商品库商品</el-button>
					</div>
				</el-form-item>
				<el-form-item label="附件资料：" prop="procurement_files">
					<div class="upload_div">
						<i slot="default" class="el-icon-plus"></i>
						<span class="upload_span">点击上传文档</span>
						<span class="upload_dec">(10个以内)</span>
					</div>
				</el-form-item>
				<el-form-item label="发货要求：" style="margin-bottom:0" prop="procurement_receive">
					<div class="add_div" v-for="(item,index) in form.procurement_receive">
						<div class="item_div">
							<el-input class="input" style="width: 290px;" v-model="item.address"
								placeholder="请输入收货地址" />
							<el-input class="input_add" v-model="item.name" placeholder="请输入收货联系人" />
							<el-input class="input_add" v-model="item.phone" placeholder="请输入收货电话" />
							<el-input class="input_add" v-model="item.remark" placeholder="请输入备注说明" />
							<el-button style="margin-left: 20px;" type="primary" plain
								@click="addItem(index+1,1)">添加</el-button>
							<el-button v-if="index > 0" type="danger" plain @click="deleteItem(index,1)">删除</el-button>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="发票税务：" prop="procurement_tax">
					<el-input class="input" v-model="form.procurement_tax" placeholder="专票/普票/税率" />
				</el-form-item>
				<el-form-item label="业务总额：" prop="procurement_amount">
					<el-input class="input" v-model="form.procurement_amount" placeholder="协商后业务总额/元" />
				</el-form-item>
				<el-form-item label="结算方式：" prop="procurement_settlement">
					<el-input class="input" v-model="form.procurement_settlement" placeholder="如：交货付款、64付款" />
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close">关闭</el-button>
			<el-button type="primary" @click="submitForm('form')">确定</el-button>
		</div>
		<!--弹出层-->
		<GoodPup :name="goodTable" :show="show" @close="goodClose" @goodList="goodList" />
	</div>
</template>

<script>
	import {
		consumerLists,
		procurementLists,
		procurementAdd,
		procurementEdit,
		procurementDetail
	} from "../../request/apis.js"
	import Tip from "../Tip/Tip.vue"
	import GoodPup from "../GoodPup/GoodPup.vue"
	export default {
		components: {
			Tip,
			GoodPup
		},
		props: {
			type: {
				type: Number
			},
			from: {
				type: Number
			}
		},
		data() {
			return {
				tip: '添加新的业务商机需求信息。',
				textarea: '请描述：项目业务目的、客户背景、主负责人及联系方式、货品诉求、附加要求等信息，以便于业务跟进。2000字符内',
				checkList: ['业务商机', '备货询价单', '客户报价单', '客户合同', '货品采购单', '货品出库单'],
				consumerList: [], //客户列表
				opportunityList: [], //商机列表
				quotationList: [], //报价单列表
				contractList: [], //合同列表
				form: {
					procurement_name: '', //简要名称
					consumer_id: '', //客户id
					opportunity_id: '', //商机id
					quotation_id: '', //报价单id
					contract_id: '', //合同id
					procurement_info: '', //项目概述
					procurement_start: '', //开始时间
					procurement_end: '', //截止时间
					procurement_files: '', //附件资料
					procurement_receive: [{ //发货要求(收货信息)
						address: '', //收货地址
						name: '', //收货联系人
						phone: '', //联系人电话
						remark: '' //备注说明
					}],
					procurement_tax: '', //发票税率
					procurement_amount: '', //业务总额
					procurement_settlement: '', //结算方式
					procurement_goods: [{
						good_id: '', //商品id
						sku_id: '', //规格id
						good_name: '', //商品名称
						sku_name: '', //商品规格
						quatity: '', //商品数量
						sale_price: '', //商品单价
						amount: '', //商品金额
						sort: '', //排序
						remark: '' //备注说明
					}] //货物明细
				},
				rules: {
					procurement_name: [{
						required: true,
						message: '请输入简要名称',
						trigger: 'blur'
					}],
					consumer_id: [{
						required: true,
						message: '请选择客户单位',
						trigger: 'blur'
					}],
					procurement_info: [{
						required: true,
						message: '请输入项目概述',
						trigger: 'blur'
					}],
					procurement_start: [{
						required: true,
						message: '请选择开始时间',
						trigger: 'blur'
					}],
					procurement_end: [{
						required: true,
						message: '请选择截止时间',
						trigger: 'blur'
					}]
				},
				page: 1, //当前页 刷新后默认显示第一页
				limit: 10, //每一页显示的数据量 此处每页显示10条数据
				total: 0, //总条数
				goodTable: '',
				show: false,
				arr: []
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333',
					padding: '0 0'
				}
			}
		},
		mounted() {
			if (this.type != -1) {
				//详情编辑
				this.form.procurement_id = this.type;
				this.getProcurementDetail();
			}
			this.getConsumerList();
			this.getProcurementList();
		},
		methods: {

			//获取商机详情
			getProcurementDetail() {
				procurementDetail({
					procurement_id: this.form.procurement_id
				}, this.from).then(res => {
					if (res.code == 0) {
						res.data.opportunity_id = res.data.opportunity_id == 0 ? '' : res.data.opportunity_id;
						res.data.contract_id = res.data.contract_id == 0 ? '' : res.data.contract_id;
						res.data.quotation_id = res.data.quotation_id == 0 ? '' : res.data.quotation_id;
						for (var key in res.data) {
							if (this.form.hasOwnProperty(key)) {
								this.form[key] = res.data[key];
							}
						}
					}
				}).catch(err => {})
			},

			//获取客户列表
			getConsumerList() {
				consumerLists({
					page: this.page,
					limit: this.limit
				}).then(res => {
					if (res.code == 0) {
						this.total = res.count
						this.consumerList = res.data
					}
				}).catch(err => {})
			},

			//获取列表
			getProcurementList() {
				if (this.from != 0 && this.from != 5) {
					//获取商机列表
					procurementLists({}, 0).then(res => {
						this.opportunityList = res.data
					})
				}
				if (this.from == 3) {
					//获取报价单列表
					procurementLists({}, 2).then(res => {
						this.quotationList = res.data
					})
				}
				if (this.from == 4 || this.from == 5) {
					//获取合同列表
					procurementLists({}, 3).then(res => {
						this.contractList = res.data
					})
				}
			},
			
			//查看客户档案&新增客户档案
			consumerClick(consumer_id){
				this.$emit('consumerEdit',consumer_id)
			},
			
			//选择商机列表时
			opportunityChange(e){
				if(this.type == -1){
					var index = this.opportunityList.findIndex(item=>item.procurement_id === parseInt(e))
					var data = this.opportunityList[index];
					for (var key in data) {
						if (this.form.hasOwnProperty(key)) {
							if(key == 'procurement_receive'){
								this.form[key] = data[key];
							}else if(key != 'procurement_name' && key != 'consumer_id' && key != 'opportunity_id' && key != 'quotation_id' && key != 'contract_id'){
								this.form[key] = data[key];
							}
						}
					}
				}
			},

			//条目添加
			addItem(index, type) {
				if (type == 0) {
					//表格加品(货物明细条目添加)
					this.form.procurement_goods.splice(index, 0, {})
				} else {
					//发货要求条目添加
					this.form.procurement_receive.splice(index, 0, {})
				}
			},

			//条目删除
			deleteItem(index, type) {
				if (type == 0) {
					//移除商品(货物明细条目删除)
					this.form.procurement_goods.splice(index, 1)
				} else {
					//发货要求条目删除
					this.form.procurement_receive.splice(index, 1)
				}
			},

			//表单提交
			submitForm(from) {
				this.$refs[from].validate((valid) => {
					if (valid) {
						if (this.type != -1) {
							//编辑
							procurementEdit({
								...this.form
							}, this.from).then(res => {
								if (res.code == 0) {
									this.$emit('close', 0)
								} else {
									this.$message.error(res.msg);
								}
							})
						} else {
							//新增
							procurementAdd({
								...this.form
							}, this.from).then(res => {
								if (res.code == 0) {
									this.$emit('close', 0)
								} else {
									this.$message.error(res.msg);
								}
							})
						}
					} else {
						return false
					}
				})
			},

			statusChange(value) {
				if (this.checkList.length > 1) {
					this.checkList.splice(0, 1)
				}
			},

			open() {
				this.goodTable = 'GoodTable';
				this.show = true
			},

			goodClose() {
				this.show = false
			},

			//更新货物明细商品列表
			goodList(list) {
				this.arr = this.arr.concat(list);
				var newArr = Array.from(new Map(this.arr.map(item => [item.sku_id, item]))).map(item => item[1]);
				newArr.map((item, index) => {
					item['sku_name'] = item.spec_data_str;
				});
				this.form.procurement_goods = newArr;
				this.show = false
			},

			//修改单价
			priceInput(index) {
				var item = this.form.procurement_goods[index];
				item.amount = parseFloat(item.sale_price * item.quatity).toFixed(2)
			},

			//计算价格
			quatityInput(index) {
				var item = this.form.procurement_goods[index];
				item.amount = parseFloat(item.sale_price * item.quatity).toFixed(2)
			},

			close() {
				this.$emit('close', 1)
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.upload_div {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 130px;
		height: 130px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
	}

	.el-icon-plus {
		font-size: 20px;
		font-weight: bolder;
		color: #606266;
	}

	.upload_span {
		font-size: 14px;
		font-weight: normal;
		line-height: normal;
		margin: 10px 0 5px 0;
	}

	.upload_dec {
		font-size: 10px;
		font-weight: normal;
		line-height: normal;
	}

	.from_div {
		padding-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 600px;
		min-height: 100%;
		padding-bottom: 66px;
	}

	/* 	/deep/.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
		content: '*';
		color: #EA0000;
		font-size: 24px;
	}
 */
	.input {
		width: 200px;
	}

	.input_add {
		width: 180px;
		margin-left: 20px;
	}

	.textarea {
		width: 550px;
		margin-top: 10px;
	}

	/deep/.el-textarea__inner {
		min-height: 104px;
		height: 104px;
	}

	/* 	/deep/.input.el-input__inner {
		border-left: none;
		border-right: none;
		border-top: none;
		border-radius: 0;
	} */

	.select {
		width: 200px;
	}

	.picker {
		width: 200px;
	}

	.check_span {
		font-size: 14px;
		color: #0256FF;
		margin-left: 30px;
	}

	.add_span {
		font-size: 14px;
		color: #00A292;
		margin: 0 30px;
	}

	.el-button--mini {
		margin-right: 10px;
	}

	.item_btn {
		margin: 0 5px 0 0;
	}
	
	.table_div {
		width: 100%;
		margin-bottom: 20px;
	}

	.table-input {
		width: 190px;
	}

	.add_div {
		display: flex;
		flex-direction: column;
	}

	.item_div {
		display: flex;
		flex-direction: row;
		margin-bottom: 20px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}
</style>